import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";

export const invoiceManagementRouter: RouteRecordRaw[] = [
    {
        path: "invoice",
        name: "InvoiceManagement",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/invoice/applyFor",
        meta: {
            title: "发票管理"
        },
        children: [
            {
                path: "applyFor",
                name: "ApplyForBilling",
                component: () => import("@/views/pages/invoiceManagement/applyForBilling/index.vue"),
                meta: {
                    title: "申请开票",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "apply/add",
                name: "ApplyForAdd",
                component: () => import("@/views/pages/invoiceManagement/applyForBilling/form.vue"),
                meta: {
                    title: "新增开票",
                    activeMenu: "ApplyForBilling",
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "apply/edit",
                name: "ApplyForEdit",
                component: () => import("@/views/pages/invoiceManagement/applyForBilling/form.vue"),
                meta: {
                    title: "修改开票",
                    isNotShowHeader: true,
                    activeMenu: "ApplyForBilling",
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "apply/detail",
                name: "ApplyForDetail",
                component: () => import("@/views/pages/invoiceManagement/applyForBilling/detail.vue"),
                meta: {
                    title: "开票详情",
                    activeMenu: "ApplyForBilling",
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "bill",
                name: "Bill",
                component: () => import("@/views/pages/invoiceManagement/billManagement/index.vue"),
                meta: {
                    title: "开票管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "bill/detail",
                name: "BillDetail",
                component: () => import("@/views/pages/invoiceManagement/billManagement/detail.vue"),
                meta: {
                    title: "开票详情",
                    activeMenu: "Bill",
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "bill/add",
                name: "BillAdd",
                component: () => import("@/views/pages/invoiceManagement/billManagement/form.vue"),
                meta: {
                    title: "新增开票",
                    activeMenu: "Bill",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "bill/edit",
                name: "BillEdit",
                component: () => import("@/views/pages/invoiceManagement/billManagement/form.vue"),
                meta: {
                    title: "修改开票",
                    isNotShowHeader: true,
                    activeMenu: "Bill",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            }
        ]
    }
];

export default invoiceManagementRouter;
